<app-auth-header [title]="title | translate" [subtitle]="subTitle | translate"></app-auth-header>
<div [formGroup]="form">
  <section>
    <div class="form-group">
      <div class="code-fields" dir="ltr" formGroupName="code">
        @for (code of code.controls; track code; let i = $index) {
          <input
            type="text"
            inputmode="numeric"
            pattern="[0-9]*"
            maxlength="1"
            [autocomplete]="i === 0 ? 'one-time-code' : 'off'"
            pInputText
            class="code-input"
            [class.filled]="!!code.value"
            [formControlName]="i"
            #inputElem
            (keydown)="onInput(i, $event)"
            (paste)="onPaste($event)"
            [attr.aria-label]="('AUTH.APPLY_RESET.DIGIT' | translate) + ' ' + (i + 1)"
            [tabIndex]="getTabIndex(i)"
            />
        }
      </div>
      <p class="forgot-line text-center">
        <span class="color-gray">{{ 'AUTH.APPLY_RESET.HAVE_NOT_RECEIVED_CODE' | translate }}</span>
        @if (resendCooldown === 0) {
          <a (click)="sendCode()" (keydown.enter)="sendCode()" tabindex="0" role="button"
            ><span class="color-primary bold cursor-pointer">{{ 'AUTH.APPLY_RESET.SEND_A_NEW_NOW' | translate }}</span></a
            >
          }
          @if (resendCooldown > 0) {
            <span class="color-gray">
              {{ 'AUTH.APPLY_RESET.RESEND_IN' | translate }} {{ resendCooldown }}{{ 'AUTH.APPLY_RESET.SECONDS_SHORT' | translate }}
            </span>
          }
        </p>
      </div>
    </section>
    <footer>
      @if (type !== 'VERIFY') {
        <p class="forgot-line text-center">
          <a i18n [routerLink]="['../', 'login']">{{ 'AUTH.FOOTER.BACK_TO_LOGIN' | translate }}</a>
        </p>
      }
    </footer>
    <div>
      <!--     <div class="space"></div>
      <a class="btn btn-primary lg" (click)="onValidateClick()">{{'AUTH.APPLY_RESET.VERIFY_PIN_CODE' | translate}}</a> -->
      <ng-content select="footer"></ng-content>
      <!--     <div class="space"></div>
      <p class="dont-have-account text-center">Don’t have an account? <a class="cursor-pointer">Create Account</a></p> -->
    </div>
  </div>
